import { getIsLogin } from '@/utils/cookie';
import { useEffect, useState } from 'react';
import HeaderUserTipsContent from './ContentA';

// 没有登录
export default function HeaderUserTipsWin({ closeCallback, className }: { closeCallback?: any; className?: string }) {
    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        if (isLogin2) {
            setIsLogin(true);
        }
    }, []);
    if (isLogin) {
        return null;
    }
    return (
        <div className="HeaderV2-user-win-h5">
            <HeaderUserTipsContent closeCallback={closeCallback} />
        </div>
    );
}
